<template>
  <section id="main-contents">
    Dashboard
  </section>
</template>

<script>
import config from '@/config/const.js'
export default {
  name: 'MainDashboard',
  props: {
  }
}
console.log(
    config
)
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#main-contents{
  min-width: 400px;
  flex: 1;
  width: auto;
  border: solid 2px #1f2d3d;
}
a {
  text-decoration: none;
}

</style>
